import React from "react";

const beliefs = [
    "I'm not good enough.",
    "I have to stay on guard.",
    "I can't trust anyone.",
    "It was my fault.",
];

export default function AnxietyEMDR() {
    return (
        <section data-testid="emdr-section" className="py-28 lg:py-40" style={{ background: "#EEF2ED" }}>
            <div className="mx-auto max-w-[1100px] px-6 lg:px-12 text-center" data-reveal>
                <span className="editorial-eyebrow">When Anxiety Is Rooted in Trauma</span>
                <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal text-balance">
                    Specialized EMDR therapy for people who <em className="italic text-gold">look</em> like they have it together.
                </h2>
                <div className="editorial-divider mt-12">
                    <span className="text-xl">✦</span>
                </div>

                <p className="mt-12 text-lg sm:text-xl leading-[1.85] text-charcoal-soft max-w-3xl mx-auto text-pretty">
                    EMDR — Eye Movement Desensitization and Reprocessing — helps your brain and body
                    metabolize painful experiences so they no longer feel as overwhelming.
                    Unlike talk therapy alone, EMDR works with the deeper emotional and physical
                    imprints of trauma — the memories, beliefs, and feelings that quietly continue
                    to shape how you see yourself.
                </p>

                <p className="mt-8 text-lg sm:text-xl leading-[1.85] text-charcoal-soft max-w-3xl mx-auto text-pretty">
                    Together, we move at a pace that feels safe. We gently work with the painful beliefs
                    that trauma so often leaves behind:
                </p>

                <ul className="mt-12 grid sm:grid-cols-2 gap-x-12 gap-y-6 max-w-2xl mx-auto" data-testid="emdr-beliefs">
                    {beliefs.map((b) => (
                        <li
                            key={b}
                            className="font-serif italic text-2xl text-gold pt-5"
                            style={{ borderTop: "1px solid #E2DDD8" }}
                        >
                            "{b}"
                        </li>
                    ))}
                </ul>

                <p className="mt-14 max-w-2xl mx-auto text-lg leading-[1.85] text-charcoal-soft">
                    As those experiences are processed, the memories soften. The fear loosens.
                    The shame begins to release. And you may find yourself, slowly, returning home
                    to who you were before the world told you who to be.
                </p>
            </div>
        </section>
    );
}
